<template>
  <div>
    <iframe height="100%" width=100% :src="path" ></iframe>
  </div>
</template>

<script>
export default {
  name: 'PDFJSViewer',
  props:['path'],
}
</script>
<style scoped>
div {
  width: 100%;
  height: 78vh;
  min-width: 400px;
}
</style>
